export const WORKSPACE_KIND = {
  frontend: 'frontend',
  general: 'general',
};
